import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material';
import { Router } from '@angular/router';



interface APILinkArray {
  source: string;
  sourceId: number;
  mapiKey: string;
  apiKey: string;
  apiSpecs: string;
}

interface PostingSpecsArray {
  sourcename: string;
  client: string;
  school: string;
  htmlspecs: string;
  xmlspecs: string;
}

var arr: APILinkArray[] = [];
var arrtwo: PostingSpecsArray[] = [];

@Component({
  selector: 'app-specs',
  templateUrl: './specs.component.html',
  styleUrls: ['./specs.component.css']
})

export class SpecsComponent implements OnInit {




  http: HttpClient;
  baseURL = '';
  displayedColumns: string[] = ['source', 'sourceId', 'mapiKey', 'apiKey', 'apiSpecs'];
  dispColumns: string[] = ['sourcename', 'school', 'htmlspecs', 'xmlspecs'];
  postingspecs: boolean = false;
  apiLinks: boolean = false;

  dataSource = new MatTableDataSource();
  dt = new MatTableDataSource();

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(@Inject(HttpClient) http: HttpClient, @Inject('BASE_URL') baseUrl: string, @Inject(Router) _router: Router) {
    this.baseURL = baseUrl;
    this.http = http;
    this.router = _router;
  }


  authenticated: string = "";
  router: Router;
  navigation: any;


  ngAfterViewInit() {
    arr = [];
    arrtwo = [];

    this.authenticated = sessionStorage.getItem('intcontId')

    if (this.authenticated == "0") {
      this.router.navigate(['/', 'login']);
    } else {


      var internalContactId = sessionStorage.getItem('intcontId');
      //var internalContactId = 12;


      let params = new HttpParams();
      params = params.append('InternalContactId', internalContactId);

      this.http.get(this.baseURL + 'api/Specs/GetAPILinks', { params: params }).subscribe(data => {
        var keys = Object.keys(data);
        var len = keys.length;

        if (len > 0) {
          this.apiLinks = true;
          for (var i = 0; i <= len - 1; i++) {
            var source = data[i]["source"];
            var sourceId = data[i]["sourceId"];
            var masterAPIKey = data[i]["mapiKey"];
            var APIKey = data[i]["apiKey"];
            var APISpecs = data[i]["apiSpecs"];


            var dataArray: APILinkArray = { source: source, sourceId: sourceId, mapiKey: masterAPIKey, apiKey: APIKey, apiSpecs: APISpecs };

            arr.push(dataArray);

          }
          this.dataSource = new MatTableDataSource(arr);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        } else {
          this.apiLinks = false;
        }

      });

      this.http.get(this.baseURL + 'api/Specs/GetPostingSpecs', { params: params }).subscribe(data => {

        var dataLength = Object.keys(data).length;
        if (dataLength > 0) {
          this.postingspecs = true;
          var keys = Object.keys(data);
          var len = keys.length;

          for (var i = 0; i <= len - 1; i++) {
            var sourcename = data[i]["source"];
            var client = data[i]["client"];
            var school = data[i]["school"];
            var htmlspecs = data[i]["htmlSpecs"];
            var xmlspecs = data[i]["xmlSpecs"];


            var dArray: PostingSpecsArray = { sourcename: sourcename, client: client, school: school, htmlspecs: htmlspecs, xmlspecs: xmlspecs };

            arrtwo.push(dArray);

          }
          this.dt = new MatTableDataSource(arrtwo);
          this.dt.paginator = this.paginator;
          this.dt.sort = this.sort;
        } else {
          this.postingspecs = false;
        }


      });
    }
  }

  toggleChanged: boolean = false;
  sidebarOpen: boolean = false;

  toggleNav() {
    console.log(this.toggleChanged);
    this.toggleChanged = !this.toggleChanged;
    this.sidebarOpen = !this.sidebarOpen;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  ngOnInit() {

  }

}
